module.exports = __webpack_public_path__ + "media/images/logo-eb1e089b4e98339618e4d826f029536f.png";